// Thrid party and librarys
import React, { useState, useEffect, useContext, useMemo } from "react";
import SideNav, { NavItem, NavIcon, NavText } from "@trendmicro/react-sidenav";
import "@trendmicro/react-sidenav/dist/react-sidenav.css";
import { useDispatch } from "react-redux";
import { useLazyQuery } from "@apollo/client";
import _ from "lodash";

// constants 
import "./sidenav.css";
import { APP_COLOR_FOCUS, COLOR_WHITE, COLOR_WHITE_200, CREATE_UPDATE_PERMISSINS, DELETED_PERMISSIONS, INLINE_PERMISSIONS, UN_SELECTED_TAB_TEXT, USER_KEY, SHOP_SETTING_KEY } from "../const";
import { GET_PRODUCT_EXPIRE, STOCK_ALMOST_GONES } from "../apollo/product/query";
import MyContext from "../MyContext";
import { addStockAlmostGones } from "../redux/reducers/stockAlmostGonesReducer";
import { removeCategoryList } from "../redux/reducers/categoryReducer";
import { removeBankList } from "../redux/reducers/bankReducer";
import { removeBrandList } from "../redux/reducers/brandReducer";
import { removePrinter } from "../redux/reducers/printerReducer";
import { ReactIcons, MuiIcons } from "../icons";
import { GET_ROLE_PERMISSIONS } from "../apollo/rolePermission/query";
import { errorSwal } from "../helper/sweetalert";
import ComfirmModal from "../components/ComfirmModal";
import { addPermission } from "../redux/reducers/roleReducer";
import { useTranslation } from "react-i18next";
// import Notification from "../components/Notification";

// constnat version app
let versionApp = require("../../package.json");

const popNoti = {
  position: "absolute",
  top: 10,
  right: 2,
  minWidth: 18,
  width: "auto",
  height: 18,
  fontSize: 8,
  borderRadius: "50%",
  background: "red",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "#fff",
};


export default function SideBarLeft({ location, history, onToggle, expanded }) {
  const dispatch = useDispatch();

  const { t } = useTranslation();

  // useState hooks
  const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
  const shopSetting = JSON.parse(localStorage.getItem(SHOP_SETTING_KEY)) || {};
  const commissionEnable = shopSetting?.commissionEnable ?? false;
  const [showConfirmLogout, setShowConfirmLogout] = useState(false);
  const [selectStatus, setSelectStatus] = useState(location.pathname.split("/")[1].split("-")[0]);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [permissions, setPermissions] = useState([])
  const [userData, setUserData] = useState();
  // const [notifyStockExpire, setNotifyStockExpire] = useState(0);


  // useContext hooks
  // const { setNotificationTotal } = useContext(MyContext);

  // apollo client hoos
  const [loadStockAlmostGones, { data: stockAlmostData }] = useLazyQuery(STOCK_ALMOST_GONES, { fetchPolicy: "network-only" });
  const [getRolePermission, { data: rolePermission, loading: loadingRole }] = useLazyQuery(GET_ROLE_PERMISSIONS, { fetchPolicy: "network-only" });
  const [getProductExpire, { data: dataProductExpire, loading: loadingProductExpire }] = useLazyQuery(GET_PRODUCT_EXPIRE, { fetchPolicy: "network-only" });

  const notifyStockExpire = useMemo(() => {
    let total = 0;
    if (dataProductExpire?.getProductExpire){
      const data = JSON.parse(dataProductExpire?.getProductExpire); // Assuming getProductExpire returns JSON data
      if (data?.status) {
        total = data?.total;
      }
    }
    return total || 0;
  }, [dataProductExpire]);
  // useEffect Hooks
  useEffect(() => {
    if (rolePermission) {
      try {
        const permissionsString = rolePermission?.user?.permission?.permissions || '[]';
        const _permissions = JSON.parse(permissionsString);
        setPermissions(_permissions);
        dispatch(addPermission(_permissions));
      } catch (error) {
        console.error("Failed to parse permissions: ", error);
      }
    }
  }, [rolePermission, dispatch]);

  useEffect(() => {
    let localData = JSON.parse(localStorage.getItem("USER_DATA"))
    if (localData) {
      setUserData(localData?.data)
      fetchPermissionDatas(localData?.data?.id)
      fetchStockExpire();
    }
  }, [])


  // fetch role and permission
  const fetchPermissionDatas = async (_shopId) => {
    try {
      if (loadingRole) return;
      await getRolePermission({
        variables: {
          where: {
            id: _shopId,
          }
        }
      })

    } catch (error) {
      console.log("error: ", error)
    }
  };

const fetchStockExpire = async () => {
  if (loadingProductExpire) return;
  try {
    await getProductExpire({ variables: { expireKey: "NEXT_MONTH" } });
  } catch (error) {
    console.log("Error in fetchStockExpire: ", error);
  }
};
  // useEffect hooks
  useEffect(() => {
    loadStockAlmostGones({
      variables: {
        orderBy: "createdAt_DESC",
        where: {
          shop: shopId,
        },
      },
    });
  }, [shopId]);

  // useEffect(() => {
  //   if (stockAlmostData?.stockAlmostGones?.data) {
  //     dispatch(addStockAlmostGones(stockAlmostData?.stockAlmostGones?.data));
  //   }
  // }, [stockAlmostData?.stockAlmostGones?.data]);

  // useEffect(() => {
  //   if (stockAlmostData?.stockAlmostGones?.total) {
  //     setNotificationTotal(stockAlmostData?.stockAlmostGones?.total);
  //   }
  // }, [stockAlmostData?.stockAlmostGones?.total]);

  useEffect(() => {
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  });

  useEffect(() => {
    alertInternet();
  }, [isOnline]);


  // check network on or off
  const handleOnline = () => setIsOnline(true);
  const handleOffline = () => setIsOnline(false);

  // check popup network error or network off
  const alertInternet = () => {
    if (isOnline) {
      return "";
    } else {
      errorSwal("ກະລຸນາເຊື່ອມຕໍ່ອິນເຕີເນັດ?");
    }
  };

  // handle logout from pos
  const _onLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    history.push(`/`);
    dispatch(removeCategoryList());
    dispatch(removeBankList());
    dispatch(removeBrandList());
    dispatch(removePrinter());
  };


 const menuItemsLeft = [
    {
      eventKey: "sale",
      icon: MuiIcons.StorefrontRoundedIcon,
      label: "sale_menu",
      divider: false
    },
    {
      eventKey: "salepage_order",
      icon: MuiIcons.ShoppingCartIcon,
      label: "salepage_menu",
      divider: false
    },
    {
      isPermission: "CREATE_QUOTAION",
      eventKey: "offerprice",
      icon: MuiIcons.BookmarkAdd,
      label: "offer_price_menu",
      font_size: 22,
      divider: false
    },
    {
      isPermission: "REPORT_STOCK_ALMOST",
      eventKey: "stocknotification",
      icon: ReactIcons.MdCircleNotifications,
      label: "product_almost_menu",
      font_size: 20,
      divider: true
    },
    {
      isPermission: "HISTORY_BILL_SALE",
      eventKey: "history_menu",
      icon: ReactIcons.FaHistory,
      label: "history_menu",
      divider: false,
      font_size: 20,
      menuChild: [
        {
          isPermission: "HISTORY_BILL_SALE",
          eventKey: "sale_history",
          icon: ReactIcons.BsDot,
          label: "sale_history_menu",
          divider: false
        },
        {
          isPermission: "HISTORY_OFFERPRICE_BILL",
          eventKey: "history_offerprices",
          icon: ReactIcons.BsDot,
          label: "offerprice_history_menu",
          divider: false
        },
        {
          isPermission: "HISTORY_INDEBTED_BILL",
          eventKey: "history_indebted",
          icon: ReactIcons.BsDot,
          label: "debt_history_menu",
          divider: false
        },
        {
          isPermission: "HISTORY_UPDATE_STOCK",
          eventKey: "historyproduct",
          icon: ReactIcons.BsDot,
          label: "edit_history_stock_menu",
          divider: false
        },
        {
          isPermission: "HISTORY_DELETED_STOCK",
          eventKey: "product_trashed",
          icon: ReactIcons.BsDot,
          label: "trush_history_menu",
          divider: false
        },
      ]
    },
    {
      isPermission: "REPORT_SALE_ONLY",
      eventKey: "order_staff",
      icon: ReactIcons.FaChartBar,
      font_size: 17,
      label: "order_staff_menu",
      divider: false
    },
    {
      isPermission: "DASHBOARD_SALE",
      eventKey: "reports_menu",
      icon: MuiIcons.BarChartIcon,
      label: "reports_menu",
      divider: true,
      font_size: 20,
      menuChild: [
        {
          isPermission: "DASHBOARD_SALE",
          eventKey: "dashboard",
          icon: ReactIcons.BsDot,
          label: "dashboard_menu",
          divider: false
        },
        {
          isPermission: "HISTORY_BILL_SALE",
          eventKey: "sale_invoice",
          icon: ReactIcons.BsDot,
          label: "report_bill_menu",
          divider: false
        },
        {
          isPermission: "DASHBOARD_SALE",
          eventKey: "sale_categories",
          icon: ReactIcons.BsDot,
          label: "report_category_menu",
          divider: false
        },
        {
          isPermission: "DASHBOARD_SALE",
          eventKey: "report_stock",
          icon: ReactIcons.BsDot,
          label: "report_stock_menu",
          divider: false
        },
        {
          isPermission: "DASHBOARD_SALE",
          eventKey: "report_redeem",
          icon: ReactIcons.BsDot,
          label: "report_redeem_menu",
          divider: false
        },
        {
          isPermission: "DASHBOARD_SALE",
          eventKey: "report_options",
          icon: ReactIcons.BsDot,
          label: "report_options",
          divider: false
        },
        ...(commissionEnable ? [{
          isPermission: "DASHBOARD_SALE",
          eventKey: "report_commission",
          icon: ReactIcons.BsDot,
          label: "ລາຍງານຄ່າຄອມມິດຊັ່ນ",
          divider: false
        }] : []),
      ]
    },
    {
      isPermission: "CREATE_INCOME_STOCK",
      eventKey: "purchase_management",
      icon: ReactIcons.AiFillTag,
      font_size: 20,
      label: "improted_stock_menu",
      divider: false
    },
    {
      isPermission: "STOCK_MANAGEMENTS",
      eventKey: "productlist",
      icon: MuiIcons.WarehouseIcon,
      font_size: 20,
      label: "stock_menu",
      divider: false
    },
    {
      isPermission: "INVENTORY_MANAGEMENTS",
      eventKey: "inventory",
      icon: MuiIcons.InventoryIcon,
      font_size: 20,
      label: "inventory_menu",
      divider: false
    },
    {
      isPermission: "SETTING_MANAGEMENT",
      eventKey: "settings",
      icon: MuiIcons.SettingsIcon,
      label: "setting_menu",
      divider: true
    },
  
  ];

  const isAdmin = userData?.role === "ADMIN";


  return (
    <SideNav
      onToggle={onToggle}
      expanded={expanded}
      style={{
        backgroundColor: COLOR_WHITE,
        height: "100vh",
        display: "block",
        position: "fixed",
        borderRight: '1px solid #f2f2f2'
      }}
      onSelect={(selected) => {
        setSelectStatus(selected.split("/")[0].split("-")[0]);
        const to = "/" + selected;
        if (location.pathname !== to) {
          if (
            to === "/investment" ||
            to === "/productlist" ||
            to === "/inventory" ||
            to === "/sale" ||
            to === "/sale_history" ||
            to === "/history_offerprices" ||
            to === "/offerprice" ||
            to === "/historyproduct" ||
            to === "/product_trashed" ||
            to === "/sale_invoice" ||
            to === "/staff_reports" ||
            to === "/order_staff" ||
            to === "/orders"
          ) {
            history.push(to + "/limit/50/page/1");
            localStorage.removeItem("CURRENT_CATEGORY");
            localStorage.removeItem("CURRENT_BRAND");
            localStorage.removeItem("CURRENT_SUBBRAND");
          } else {
            history.push(to);
          }
        }
      }}
    >
      <SideNav.Toggle style={{ color: "black" }}  />

      {isAdmin ? (
        <SideNav.Nav defaultSelected={location.pathname.split("/")[1]}>
          {menuItemsLeft?.map((item, index) => (
            <NavItem
              eventKey={item?.eventKey}
              key={index}
              style={{
                borderBottom: item?.divider ? `1px solid #ddd` : "none",
                marginBottom: item?.divider ? 7 : 0,
                paddingBottom: item?.divider ? 7 : 0,
              }}
            >
              <NavIcon>
                <item.icon
                  style={{
                    fontSize: item?.iconSize ? item?.iconSize : 20,
                    color: selectStatus === item?.eventKey ? APP_COLOR_FOCUS : "#222E3C",
                  }}
                />
              </NavIcon>
              <NavText
                style={{
                  color: selectStatus === item?.eventKey ? APP_COLOR_FOCUS : UN_SELECTED_TAB_TEXT,
                  fontSize: 14,
                  fontWeight: 'bold'
                }}
              >
                {t(item?.label)}
              </NavText>

              {/* Render menuChild if it exists and has valid permissions */}
              {item.menuChild?.length > 0 &&
                item.menuChild.map((childItem, childIndex) => (
                  <NavItem
                    index={childIndex}
                    eventKey={childItem?.eventKey}
                    key={childIndex}
                    style={{
                      height: 40,
                    }}
                  >
                    <NavText
                      style={{
                        width: 200,
                        height: 40,
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        color:
                          selectStatus === childItem?.eventKey
                            ? APP_COLOR_FOCUS
                            : UN_SELECTED_TAB_TEXT,
                      }}
                    >
                      <div style={{ width: 15 }} />
                      <ReactIcons.BsDot
                        style={{
                          fontSize: "20px",
                          color:
                            selectStatus === childItem?.eventKey
                              ? APP_COLOR_FOCUS
                              : "#222E3C",
                        }}
                      />
                      <div style={{ width: 10 }} />
                      <p style={{ margin: 0, fontSize: 13 }}>{t(childItem?.label)}</p>
                    </NavText>
                  </NavItem>
                ))
              }
            </NavItem>
          ))}
          <NavItem onClick={() => setShowConfirmLogout(true)}>
            <NavIcon>
              <MuiIcons.LogoutIcon
                style={{
                  fontSize: 20, fontWeight: 'bold',
                  color: selectStatus === "" ? APP_COLOR_FOCUS : "#222E3C",
                }}
              />
            </NavIcon>
            <NavText
              style={{
                color:
                  selectStatus === "" ? APP_COLOR_FOCUS : UN_SELECTED_TAB_TEXT,
                fontSize: 16,
                fontWeight: 'bold'
              }}
            >
              {t("logout_menu")}
            </NavText>
          </NavItem>
          <div
            style={{
              textAlign: "center",
              left: "0px",
              right: "0px",
              fontSize: "10",
              display: "flex",
              bottom: "50px",
              flexDirection: "column",
              position: "absolute",
            }}
          >
            {isOnline ? (
              <div>
                <MuiIcons.WifiIcon sx={{ color: "#008000", fontSize: "25px" }} />
              </div>
            ) : (
              <div>
                <MuiIcons.WifiOffIcon sx={{ color: "red", fontSize: "25px" }} />
              </div>
            )}
          </div>
          <div
            style={{
              fontSize: 10,
              color: "#6B7280",
              fontWeight: "bold",
              textAlign: "center",
              bottom: "20px",
              position: "absolute",
              left: "0px",
              right: "0px",
            }}
          >
            {versionApp.version}
          </div>
        </SideNav.Nav>
      ) : (
        <SideNav.Nav defaultSelected={location.pathname.split("/")[1]}>
          {menuItemsLeft?.filter(item => !item.isPermission || permissions.includes(item?.isPermission)).map((item, index) => (
            <NavItem
              eventKey={item?.eventKey}
              key={index}
              style={{
                borderBottom: item?.divider ? `1px solid #ddd` : "none",
                marginBottom: item?.divider ? 7 : 0,
                paddingBottom: item?.divider ? 7 : 0,
              }}
            >
              <NavIcon>
                <item.icon
                  style={{
                    fontSize: item?.font_size ?? 23,
                    color: selectStatus === item?.eventKey ? APP_COLOR_FOCUS : "#222E3C",
                  }}
                />
                {item?.eventKey === "stocknotification" ? <span style={popNoti}>{stockAlmostData?.stockAlmostGones?.total > 0 ? stockAlmostData?.stockAlmostGones?.total : 0}</span> : ""}
                {item?.eventKey === "productlist" ? <span style={popNoti}>{notifyStockExpire}</span> : ""}
              </NavIcon>
              <NavText
                style={{
                  color: selectStatus === item?.eventKey ? APP_COLOR_FOCUS : UN_SELECTED_TAB_TEXT,
                  fontSize: 16,
                  fontWeight: 'bold'
                }}
              >
                {t(item?.label)}
              </NavText>

              {/* Render menuChild if it exists and has valid permissions */}
              {item.menuChild?.length > 0 &&
                item.menuChild
                  .filter(childItem => !childItem.isPermission || permissions.includes(childItem?.isPermission)) // Filter based on permissions
                  .map((childItem, childIndex) => (
                    <NavItem
                      index={childIndex}
                      eventKey={childItem?.eventKey}
                      key={childIndex}
                      style={{
                        height: 40,
                      }}
                    >
                      <NavText
                        style={{
                          width: 200,
                          height: 40,
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          color:
                            selectStatus === childItem?.eventKey
                              ? APP_COLOR_FOCUS
                              : UN_SELECTED_TAB_TEXT,
                        }}
                      >
                        <div style={{ width: 15 }} />
                        <ReactIcons.BsDot
                          style={{
                            fontSize: "20px",
                            color:
                              selectStatus === childItem?.eventKey
                                ? APP_COLOR_FOCUS
                                : "#222E3C",
                          }}
                        />
                        <div style={{ width: 10 }} />
                        <p style={{ margin: 0, fontSize: 15 }}>{t(childItem?.label)}</p>
                      </NavText>
                    </NavItem>
                  ))
              }
            </NavItem>
          ))}
          <NavItem onClick={() => setShowConfirmLogout(true)}>
            <NavIcon>
              <MuiIcons.LogoutIcon
                style={{
                  fontSize: 20, fontWeight: 'bold',
                  color: selectStatus === "" ? APP_COLOR_FOCUS : "#222E3C",
                }}
              />
            </NavIcon>
            <NavText
              style={{
                color:
                  selectStatus === "" ? APP_COLOR_FOCUS : UN_SELECTED_TAB_TEXT,
                fontSize: 14,
                fontWeight: 'bold'
              }}
            >
              {t("logout_menu")}
            </NavText>
          </NavItem>
          <div
            style={{
              textAlign: "center",
              left: "0px",
              right: "0px",
              fontSize: "10",
              display: "flex",
              bottom: "50px",
              flexDirection: "column",
              position: "absolute",
            }}
          >
            {isOnline ? (
              <div>
                <MuiIcons.WifiIcon sx={{ color: "#008000", fontSize: "25px" }} />
              </div>
            ) : (
              <div>
                <MuiIcons.WifiOffIcon sx={{ color: "red", fontSize: "25px" }} />
              </div>
            )}
          </div>
          <div
            style={{
              fontSize: 10,
              color: "#6B7280",
              fontWeight: "bold",
              textAlign: "center",
              bottom: "20px",
              position: "absolute",
              left: "0px",
              right: "0px",
            }}
          >
            {versionApp.version}
          </div>
        </SideNav.Nav>
      )}


      {/* PopupConfirm Logout */}
      <ComfirmModal
        showConfirmModal={showConfirmLogout}
        handleCancel={() => setShowConfirmLogout(false)}
        handleConfirm={_onLogout}
        title="ແຈ້ງເຕືອນ"
        text="ຕ້ອງການອອກຈາກລະບົບແທ້ບໍ?"
      />

     {/* <Notification detail="ມີສິນຄ້າ 4 ລາຍການໃກ້ໝົດອາຍຸແລ້ວ" /> */}

    </SideNav>
  );
}



